import React from "react";
import { compose, withHandlers, withPropsOnChange, withState } from "recompose";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import { keys } from "lodash";
import { XeroClient } from "services";
import { PendingButton } from "components/common";
import { NotificationManager } from "react-notifications";
import { Trans, withTranslation } from "react-i18next";

const DeleteModal = ({ isOpen, toggle, numSelected, onConfirm, pending }) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalBody>
      <Trans>
        Are you sure you want to archive the {{ numSelected }} selected row(s)
      </Trans>
    </ModalBody>
    <ModalFooter>
      <PendingButton color="primary" pending={pending} onClick={onConfirm}>
        Confirm
      </PendingButton>{" "}
      <Button color="secondary" onClick={toggle}>
        <Trans>Cancel</Trans>
      </Button>
    </ModalFooter>
  </Modal>
);

const enhance = compose(
  withTranslation(),
  withState("pending", "setPending", false),
  withPropsOnChange(["selected"], ({ selected: tmpSelected }) => {
    const selected = keys(tmpSelected);

    return {
      numSelected: selected.length,
      selected,
    };
  }),
  withHandlers({
    onConfirm:
      ({
        onConfirm,
        selected,
        onDeleted,
        isOpen,
        toggle,
        setPending,
        setError,
        t,
      }) =>
      () => {
        setPending(true);
        let promise = null;
        if (onConfirm) {
          promise = onConfirm();
        } else {
          const xero = XeroClient();
          promise = xero.put(
            "contactgroups",
            selected.map((id) => ({ ContactGroupID: id, Status: "DELETED" }))
          );
        }

        promise
          .then(() => {
            if (setError) setError(null);
            onDeleted(null);
          })
          .catch((err) => {
            if (setError) setError(err.response.data);
            NotificationManager.error(t("Archive failed"));
          })
          .finally(() => {
            if (isOpen) toggle();
            setPending(false);
          });
      },
  })
);

const ArchiveModal = enhance(DeleteModal);

const BulkArchiveButton = ({
  toggleModal,
  selected,
  onDeleted,
  isModalOpen,
  setError,
  buttonProps,
  modalProps,
  readOnly,
  ...props
}) => {
  const numSelected = keys(selected).length;

  if (readOnly) return null;

  return (
    <div {...props}>
      <Button
        onClick={toggleModal}
        disabled={!numSelected}
        color="danger"
        {...buttonProps}
      >
        <span className="fa fa-archive" /> <Trans>Archive selected</Trans>{" "}
        {!!numSelected && <span>({numSelected})</span>}
      </Button>
      <ArchiveModal
        onDeleted={onDeleted}
        isOpen={isModalOpen}
        toggle={toggleModal}
        selected={selected}
        setError={setError}
      />
    </div>
  );
};

export default BulkArchiveButton;
